module.exports = __webpack_public_path__ + "static/media/lcs_60y_y-1.df8e3e52.csv";